import { useState, useRef, useEffect } from 'react';
import { isMobile } from 'react-device-detect';
const FinancialManagement = () => {

  const scrollRef = useRef(null);
  const [fixed, setFixed] = useState(false); // default to true
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const top = scrollRef.current.getBoundingClientRect().top;
      if (top > 0) {
        setFixed(false);
      } else {
        setFixed(true);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className={`financial-management ${isMobile && 'm-fin'}`} ref={scrollRef}>
      <div className={`${!isMobile && 'overlay'}`}>
        <div className={`${!isMobile && 'overlay-opacity'}`}>
          <div className="financial-section">
            <div className="box">
              <div className="financial-title">FINANCIAL MANAGEMENT</div>
              <p className="financial-detail">
                We can help with all your community’s financial management
                obligations while ensuring your fiduciary responsibilities to your
                homeowners are met. Below is a listing of just some of the services
                we offer:
              </p>
              <ul>
                <li>Collection of homeowner dues</li>
                <li>Preparation of financial statements</li>
                <li>Budget preparation and distribution</li>
                <li>
                  Record keeping of board meeting minutes and association records
                </li>
                <li>Preparation of the association tax return filing</li>
                <li>Monthly bank account reconciliation reports</li>
                <li>Lock box system for homeowner dues and assessment payments</li>
                <li>
                  Online system for accepting homeowner dues and assessment payments
                </li>
                <li>
                  Printing and mailing of monthly bills and payment delinquency
                  letters
                </li>
                <li>Answering homeowner billing questions quickly</li>
                <li>
                  Maintaining and updating fee collection and delinquency reports
                </li>
                <li>Complete in-house collections</li>
                <li>
                  Representing the Board in Small Claims Court for dues collection
                </li>
                <li>Sending out monthly developer bills</li>
                <li>Paying all association bills on a current basis</li>
                <li>Preparing checks by hand or by computer</li>
              </ul>
            </div>
            <div className="d-flex flex-column justify-content-center" style={{ margin: 'auto' }}>
              <div className="box-separator"></div>
            </div>
            <div className="box">
              <div className="financial-title">FULL MANAGEMENT SERVICES</div>
              <p className="financial-detail">
                We believe that a community is more than just a place to live – it’s
                a place for families and friends to gather, for recreation and
                relaxation, and for building lasting memories. That’s why we work
                hard to help you keep your communities beautiful through services
                such as:
              </p>
              <ul>
                <li>Property Manager available by phone 24 hours a day</li>
                <li>Frequent property inspections</li>
                <li>
                  Supplying copies of inspection notes to Board Members, within one
                  day after inspections
                </li>
                <li>
                  Conducting walk-throughts with contractors, vendors and Board
                  Members
                </li>
                <li>Drafting regular maintenance reports</li>
                <li>Managing violations and CC&R compliance</li>
                <li>Coordinate and attend all board and committee meetings</li>
                <li>
                  Prepare and deliver complete Board Member packages one week prior
                  to meetings
                </li>
                <li>
                  Quick response to homeowner and board member requests and
                  correspondence
                </li>
                <li>Processing architectural requests</li>
                <li>Obtaining competitive bids from contractors and vendors</li>
                <li>Supervision of on-site projects, vendors and contractors</li>
                <li>Monitoring and updating association insurance requirements</li>
                <li>
                  Reviewing contracts with the Board and making recommendations as
                  needed
                </li>
                <li>Processing of liens and collections</li>
                <li>Processing of renewals and policy changes</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinancialManagement;
